var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import './tabs.styles.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Collapse, Navbar, Nav, NavItem, NavLink } from 'reactstrap';
var Tabs = /** @class */ (function (_super) {
    __extends(Tabs, _super);
    function Tabs(props) {
        var _this = _super.call(this, props) || this;
        _this.onTabClick = function (tab) {
            var clickHandler = _this.props.clickHandler;
            _this.setState({
                currentTab: tab,
            });
            clickHandler && clickHandler(tab);
        };
        _this.renderAllTabs = function () {
            var tabConstants = _this.props.tabConstants;
            var currentTab = _this.state.currentTab;
            var data = tabConstants.map(function (tabValue, index) {
                return (React.createElement(React.Fragment, { key: index },
                    React.createElement(NavItem, null,
                        React.createElement(NavLink, { onClick: function () { return _this.onTabClick(tabValue['accessor']); }, className: currentTab === tabValue['accessor'] ? 'active' : '' }, tabValue['title']))));
            });
            return data;
        };
        _this.state = {
            isOpen: false,
            currentTab: props.currentTab || '',
        };
        return _this;
    }
    Tabs.prototype.render = function () {
        return (React.createElement("div", { className: "tabs-block" },
            React.createElement(Navbar, { expand: "md" },
                React.createElement(Collapse, { isOpen: this.state.isOpen, navbar: true },
                    React.createElement(Nav, { className: "tabs", navbar: true }, this.renderAllTabs())))));
    };
    return Tabs;
}(React.Component));
export default Tabs;
//# sourceMappingURL=tabs.js.map